import React from 'react';
import { FeaturedBrandsSliderItem } from '@/types/homepage';
import Image from 'next/image';
import './index.less';

interface IProps {
  brand: FeaturedBrandsSliderItem;
}

const BrandCard = ({ brand: initBrand }: IProps) => {
  const { image, name, logo, width, height, brand } = initBrand;

  return (
    <div className="brand-card">
      <Image
        src={image}
        sizes="auto,(min-width:640px) 250px,(min-width:400px) 172px,(min-width:361px) 160px,150px"
        loading="lazy"
        width={500}
        height={580}
        alt={name}
        title={name}
      />
      <div className="info">
        <Image
          className="brand-logo"
          src={logo}
          alt={name}
          title={name}
          width={width}
          height={height}
          loading="lazy"
          fetchPriority="low"
        />
        <div className="text">
          <p className="brand">{brand}</p>
          <p className="name">{`Founded by ${name}`}</p>
        </div>
      </div>
    </div>
  );
};

export default BrandCard;
